// extracted by mini-css-extract-plugin
export default {"container":"HomePageStats_container__kQHWZ"};